import { render, staticRenderFns } from "./journey-sidebar-next.vue?vue&type=template&id=300f9bf6&scoped=true&"
import script from "./journey-sidebar-next.vue?vue&type=script&lang=js&"
export * from "./journey-sidebar-next.vue?vue&type=script&lang=js&"
import style0 from "./journey-sidebar-next.vue?vue&type=style&index=0&id=300f9bf6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300f9bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300f9bf6')) {
      api.createRecord('300f9bf6', component.options)
    } else {
      api.reload('300f9bf6', component.options)
    }
    module.hot.accept("./journey-sidebar-next.vue?vue&type=template&id=300f9bf6&scoped=true&", function () {
      api.rerender('300f9bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/client-journey/components/journey-sidebar-next/journey-sidebar-next.vue"
export default component.exports